export default __webpack_public_path__ + "static/media/4.PopularPharmaceuticalsLtd.,Tongi.1e5fcae0.jpg";